/*@flow*/

export default () => {
  const { protocol, host, pathname, hash, search } = window.location;
  return `${protocol}//${host}${pathname}${hash}${search}`;
};
